/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteTunneledMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteTunneledMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteTunneledMcpServerSecurity = {
  option1?: DeleteTunneledMcpServerSecurityOption1 | undefined;
  option2?: DeleteTunneledMcpServerSecurityOption2 | undefined;
};

export type DeleteTunneledMcpServerRequest = {
  /**
   * The ID of the tunneled MCP server to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteTunneledMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteTunneledMcpServerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteTunneledMcpServerSecurityOption1$Outbound,
    DeleteTunneledMcpServerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteTunneledMcpServerSecurityOption1ToJSON(
  deleteTunneledMcpServerSecurityOption1:
    DeleteTunneledMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteTunneledMcpServerSecurityOption1$outboundSchema.parse(
      deleteTunneledMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteTunneledMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteTunneledMcpServerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteTunneledMcpServerSecurityOption2$Outbound,
    DeleteTunneledMcpServerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteTunneledMcpServerSecurityOption2ToJSON(
  deleteTunneledMcpServerSecurityOption2:
    DeleteTunneledMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteTunneledMcpServerSecurityOption2$outboundSchema.parse(
      deleteTunneledMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteTunneledMcpServerSecurity$Outbound = {
  Option1?: DeleteTunneledMcpServerSecurityOption1$Outbound | undefined;
  Option2?: DeleteTunneledMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteTunneledMcpServerSecurity$outboundSchema: z.ZodMiniType<
  DeleteTunneledMcpServerSecurity$Outbound,
  DeleteTunneledMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteTunneledMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteTunneledMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteTunneledMcpServerSecurityToJSON(
  deleteTunneledMcpServerSecurity: DeleteTunneledMcpServerSecurity,
): string {
  return JSON.stringify(
    DeleteTunneledMcpServerSecurity$outboundSchema.parse(
      deleteTunneledMcpServerSecurity,
    ),
  );
}

/** @internal */
export type DeleteTunneledMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteTunneledMcpServerRequest$outboundSchema: z.ZodMiniType<
  DeleteTunneledMcpServerRequest$Outbound,
  DeleteTunneledMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteTunneledMcpServerRequestToJSON(
  deleteTunneledMcpServerRequest: DeleteTunneledMcpServerRequest,
): string {
  return JSON.stringify(
    DeleteTunneledMcpServerRequest$outboundSchema.parse(
      deleteTunneledMcpServerRequest,
    ),
  );
}
